<template lang="pug">
    DropDown#picker.hzDatepickerWrap(ref="picker", tabIndex="-1", @beforeShow="beforeShow", @show="show", :isSetMinWidth="false", :disabled="disabled")
        template(slot="dropHead")
            input#ipt.hzFormElement(ref="ipt", :name="name", :required="required", type="text", v-model.trim="currentValue", :style="iptStyle", :placeholder="placeholder", autocomplete="off", @input="dispatchInput", :disabled="disabled")

        .zDatepicker(slot="dropBody")
            #head.zDatepickerHd(ref="head")
                span.zDatepickerPrev(@click="headClickHandler(-1)") &lt;
                span.zDatepickerViewSwith(@click="headClickHandler(0)") {{headText}}
                span.zDatepickerNext(@click="headClickHandler(1)") &gt;
            #body.zDatepickerBd(ref="body", @click="bodyClickHandler($event)", @mouseover="bodyMouseover", @mouseout="bodyMouseout")
                table.zDatepickerViewMonth(v-if="currentView === 'year'")
                    tbody
                        tr(v-for="row in 4")
                            td(v-for="col in 3" :class="getYearTdClass(row, col)",) {{getYearText(row, col)}}

                table.zDatepickerViewMonth(v-if="currentView === 'month'")
                    tbody
                        tr(v-for="row in 4")
                            td(:data-val="(row - 1) * 3 + col - 1", :class="getMonthTdClass(row, col)", v-for="col in 3") {{monthText[(row - 1) * 3 + col - 1]}}

                table.zDatepickerViewDay(v-if="currentView ==='day'")
                    thead
                        tr
                            th 日
                            th 一
                            th 二
                            th 三
                            th 四
                            th 五
                            th 六
                    tbody
                        //- 输出42个格子
                        tr(v-for="row in 6")
                            td(v-for="col in 7", :class="getDayTdClass(row, col)", v-html="getDayText(row, col)")

                table.zDatepickerViewTime.mt5.mb5(v-if="currentView ==='hour'")
                    tbody
                        tr(v-for="row in 5")
                            td(v-for="col in 5", :class="getHourTdClass(row, col)", v-html="row === 5 && col === 5? '' : limitedTwo((row - 1) * 5 + col -1)")

                table.zDatepickerViewTime.mt5.mb5(v-if="currentView ==='minute' || currentView === 'second'")
                    tbody
                        tr(v-for="row in 7")
                            td(v-for="col in 9" :class="getMSTdClass(row, col)") {{row === 7 && col > 6? '' : limitedTwo((row - 1) * 9 + col -1)}}

                table.zDatepickerViewSeason.mt15(v-if="currentView ==='season'")
                    tbody
                        tr(v-for="row in 2")
                            td(v-for="col in 2", :data-val="(row-1) * 2 + col") {{seasonText[(row - 1) * 2 + col -1]}}

                table.zDatepickerViewWeek(v-if="currentView ==='week'")
                    tbody
                        tr(v-for="row in 7")
                            td(v-for="col in 8") {{getWeekText(row, col)}}
                            
                                
</template>

<script>
    import DropDown from './dropdown';
    export default {
        name: 'hz-datepicker',
        components: { DropDown },

        props: {
            disabled: { type: Boolean, default: false },
            value: null,
            required: { type: Boolean, default: null },
            placeholder: null,
            iptStyle: null,
            name: { type: String, default: null },
            //"year", "season", "month", "week", "day", "hour", "minute", "second", "millisecond", default is day
            minview: { type: String, default: 'day' },
            min: String,
            max: String,
            monthText: { type: Array, default: e => ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一', '十二'] },
            viewText: { type: Array, default: e =>["year", "season", "month", "week", "day", "hour", "minute", "second", "millisecond"] },
            seasonText: { type: Array, default: e =>['一季度', '二季度', '三季度', '四季度'] },
            viewPrefixMap: { type: Object, default: e => ({
                    year: '',
                    month: '-',
                    day: '-',
                    week: '',
                    season: '',
                    hour: ' ',
                    minute: ':',
                    second: ':'
                })
            },
            
            //是否在week前加上W字符，如 W201750
            isWeekUnit: { type: Boolean, default: false},
            isSeasonUnit: { type: Boolean, default: false},
        },

        data() {
            return {
                oneDay: 24 * 60 * 60000,
                currentValue: this.value || '',
                currentViewStep: 0,
                currentValueQuene: [],
                // currentViewValue: 0,
                currentMonthValue: 0,
                currentYearValue: 0,
                _timer: null,
                _currViewIndex: null,
                currDate: new Date().getTime(),
                _viewDate: null, //当前view显示的数据，如201601，表示当前view显示的为2016年01月的天数数据
                
                body: null
            }
        },

        computed: {
            _viewOriginQuene() {
                return {
                    'day': ['year', 'month', 'day'],
                    'month': ['year', 'month'],
                    'year': ['year'],
                    'hour': ['year', 'month', 'day', 'hour'],
                    'minute': ['year', 'month', 'day', 'hour', 'minute'],
                    'second': ['year', 'month', 'day', 'hour', 'minute', 'second'],
                    'season': ['year', 'season'],
                    'week': ['year', 'week']
                }[this.minview || 'day'];
            },

            currentView() {
                return this._viewOriginQuene[this.currentViewStep - 1];
            },

            _valueOriginQuene() {
                let ret = [];

                var defaultValue = this.currentValue.replace(/\-/g, '/');
                if(/^(-?[1-9]\d*|[0]{1,1})d$/.test(defaultValue)) {
                    let now = new Date().getTime();
                    defaultValue = hz.date.format(now + parseInt(defaultValue) * 24 * 60 * 60000);
                }

                var minview = (this.minview || 'day').toLowerCase();

                if(minview !== 'week' && minview !== 'season') {
                    if(minview === 'hour' && defaultValue) {
                        defaultValue += ':00';
                    }
                    try {
                        defaultValue = new Date(defaultValue || new Date());
                    }
                    catch(err) {
                        defaultValue = new Date();
                    }
                    
                    var nowVal = {
                        year   : defaultValue.getFullYear(),
                        month  : defaultValue.getMonth(),
                        day    : defaultValue.getDate(),
                        hour   : defaultValue.getHours(),
                        minute : defaultValue.getMinutes(),
                        second : defaultValue.getSeconds()
                    }
                    for(var i = 0; i < this.currentViewStep; i ++) {
                        ret.push( nowVal[this._viewOriginQuene[i]] );
                    }

                    return ret;
                }
                
                if(defaultValue) {
                    defaultValue = defaultValue.toString();
                }
                
                if(minview === 'week') {
                    defaultValue = defaultValue? defaultValue.replace('W', ''): hz.date.getWeekString(new Date());
                    
                    return [defaultValue.slice(0, 4), defaultValue.slice(4, 6)];
                }
                
                if(minview === 'season') {
                    var year = null;
                    var season = null;
                    if(defaultValue) {
                        defaultValue =  defaultValue.replace('S', '');

                        return [defaultValue.slice(0, 4), defaultValue.slice(4, 6)]
                    }
                    var date = new Date();
                    year = new Date().getFullYear();
                    season = parseInt(new Date().getMonth() / 4) + 1;

                    return [year, season];
                }
            },

            firstDayTimespan() {
                if(!this.currentValueQuene || this.currentValueQuene.length < 2) {
                    return null;
                }

                var firstDay = new Date(this.currentValueQuene[0], this.currentValueQuene[1]);
                var day = firstDay.getDay();
                return firstDay.getTime() - day * 24 * 60 * 60000;
            },

            headText() {
                if(this.currentViewStep === 1) {
                    let startYear = parseInt(this.currentValueQuene[0] / 10) * 10;
                    return startYear + ' - ' + (startYear + 10);
                }

                let ret = '';
                for(var i = 0; i < this.currentViewStep - 1; i ++) {
                    let viewText = this._viewOriginQuene[i];
                    let value = this.currentValueQuene[i];
                    if(viewText === 'month') {
                        value ++;
                    }
                    ret += this.viewPrefixMap[viewText] + this.limitedTwo(value);
                }

                return ret;
            }
        },

        watch: {
            value() {
                this.setDefault();
            },

            minview() {
                Object.assign(this.$data, this.$options.data());
                this.setDefault();
            }
        },

        mounted() {
            this.init();
            this.setDefault();        

            this.$refs.ipt.onchange = e => {
                this.currentValue = e.target.value;
                const currentValue = this.currentValue.replace(/\-/g, '/');
                const currentTime = new Date(currentValue).getTime();
                if(!currentTime || (this.max && currentTime > new Date(this.max.replace(/\-/g, '/')).getTime()) || 
                    (this.min && currentTime < new Date(this.min.replace(/\-/g, '/')).getTime())){
                    this.currentValue = '';
                    this.$emit("input", '');
                }
            }
        },

        methods: {
            setDefault() {
                if(this.value){
                    this.currentValue = this.value
                    let handleValue = this.currentValue;
                    if(this.minview == 'hour'){
                        handleValue = this.currentValue.slice(0, 10)
                    }
                    try {
                        this.currentYearValue = hz.date.format(new Date(handleValue.replace(/\-/g, '/')), 'yyyy')
                    } catch (error) {
                    }
                    try {
                        this.currentMonthValue = hz.date.format(new Date(handleValue.replace(/\-/g, '/')), 'mm');
                    } catch (error) {
                    }
                }else{
                    this.currentValue = '';
                    this.currentMonthValue = '';
                    this.currentYearValue = '';
                }
            },

            //初始化 -----
            init() {  
                this.currentViewStep = this._viewOriginQuene.length > 3? 3: this._viewOriginQuene.length;
                this.currentValueQuene = this._valueOriginQuene.length > 1? this._valueOriginQuene.slice(0, -1) : this._valueOriginQuene.slice(0); 
            },

            limitedTwo(val) {
                if(!val) {
                    return '00';
                }
                if(val.toString().length === 1) {
                    return '0' + val.toString();
                }
                return val;
            }, 

            getYearTdClass(row, col){
                const year = this.getYearText(row, col)
                if(year == this.currentYearValue){
                    return 'active'
                }else{
                    return ''
                }
            },

            getMonthTdClass(row, col){
                const year = this.currentValueQuene[0] || '';
                if(year == this.currentYearValue && this.currentMonthValue == ((row - 1) * 3 + col )){
                    return 'active'
                }else{
                    return '';
                }
            },

            getDayTdClass(row, col) {
                if(row === 6 && col === 7) {
                    return 'zDatepickerTrash';
                }
                if(row === 6 && col > 4) {
                    return '';
                }
                let timespan = this.firstDayTimespan + this.oneDay * ((row - 1) * 7 + col -1);
                let time = new Date(timespan);
                let month = time.getMonth();
                let year = time.getFullYear();
                let day = time.getDate();
                

                //设置最大，最小
                let date = [year, this.limitedTwo(month + 1), this.limitedTwo(day)].join("/");
                
                if(this.max && new Date(date).getTime() > new Date(this.max.replace(/\-/g, '/')).getTime()){
                    return 'zDatepickerMax'
                }

                if(this.min && new Date(date).getTime() < new Date(this.min.replace(/\-/g, '/')).getTime()){
                    return 'zDatepickerMin'
                }


                if(year < this.currentValueQuene[0]) {
                    return 'zDatepickerOld';
                }
                else if(year > this.currentValueQuene[0]) {
                    return 'zDatepickerNew';
                }

                if(month < this.currentValueQuene[1]) {
                    return 'zDatepickerOld';
                }
                else if(month > this.currentValueQuene[1] ) {
                    return 'zDatepickerNew';
                }

                if(hz.date.format(new Date(this.currentValue.replace(/\-/g, '/')), 'yyyy/mm/dd') == date){
                    return 'active'
                }

                return '';
            },

            getHourTdClass(row, col){
                const value = (row === 5 && col === 5) ? '' : this.limitedTwo((row - 1) * 5 + col -1)
                const date = new Date();
                date.setFullYear(this.currentValueQuene[0])
                date.setMonth(this.currentValueQuene[1])
                date.setDate(this.currentValueQuene[2])
                const selectDate = hz.date.format(date, 'yyyy/mm/dd')
                const currentValue = hz.date.format(new Date(this.currentValue.replace(/\-/g, '/')), 'yyyy/mm/dd hh');

                if(selectDate == currentValue.slice(0, 10) && currentValue.slice(11) == value){
                    return 'active'
                }else{
                    return ''
                }
            },

            getMSTdClass(row, col){
                const value = (row === 7 && col > 6) ? '' : this.limitedTwo((row - 1) * 9 + col -1)
                const date = new Date();
                date.setFullYear(this.currentValueQuene[0])
                date.setMonth(this.currentValueQuene[1])
                date.setDate(this.currentValueQuene[2])
                date.setHours(this.currentValueQuene[3])

                let selectDate, currentValue, index;

                if(this.currentView == 'minute'){
                    index = 13;
                    selectDate = hz.date.format(date, 'yyyy/mm/dd hh');
                    currentValue = hz.date.format(new Date(this.currentValue.replace(/\-/g, '/')), 'yyyy/mm/dd hh:MM');
                }else{
                    date.setMinutes(this.currentValueQuene[4])
                    index = 15;
                    selectDate = hz.date.format(date, 'yyyy/mm/dd hh:MM');
                    currentValue = hz.date.format(new Date(this.currentValue.replace(/\-/g, '/')), 'yyyy/mm/dd hh:MM:ss');
                }
                
                if(selectDate == currentValue.slice(0, index) && currentValue.slice(-2) == value){
                    return 'active'
                }else{
                    return ''
                }
            },

            getDayText(row, col) {
                if(row === 6 && col === 7) {
                    return '<i class="fa fa-trash" style="color: #aaa"></i>';
                }
                if(row === 6 && col > 4) {
                    return '';
                }

                let timespan = this.firstDayTimespan + this.oneDay * ((row - 1) * 7 + col -1);
                let time = new Date(timespan);
                let month = time.getMonth();
                let date = time.getDate();

                return this.limitedTwo(date);
            },

            getYearText(row, col) {
                if(row === 4 && col > 2) {
                    return '';
                }
                if(!this.currentValueQuene[0]) {
                    return '';
                }

                let startYear = parseInt(this.currentValueQuene[0] / 10);
                startYear *= 10;

                return startYear + (row - 1) * 3 + col - 1;
            },

            getWeekText(row, col) {
                let allWeeks = hz.date.getWeeksByYear(this.currentValueQuene[0]);
                let week = (row - 1) * 8 + col;

                return week > allWeeks? '' : week;
            },

            beforeShow() {
                this.currentViewStep = this._viewOriginQuene.length > 3? 3: this._viewOriginQuene.length;
            },

            show () {
                // Object.assign(this.$data, this.$options.data())
                this.body = this.$refs.body;
                this.init();
                // this._initViewDataQuene();
                
                // this._showView();
                // this._setActiveStatus();
            },

            dispatchInput() {
                this.$nextTick( e => {
                    this.$emit('input', this.currentValue);
                })
            },

            setCurrentValue() {
                let ret = '';
                for(var i = 0; i < this.currentViewStep; i ++) {
                    let viewText = this._viewOriginQuene[i];
                    let value = this.currentValueQuene[i];
                    if(viewText === 'month') {
                        value ++;
                    }
                    ret += this.viewPrefixMap[viewText] + this.limitedTwo(value);
                }

                this.currentValue = ret;
                this.$refs.picker && this.$refs.picker.hide && this.$refs.picker.hide();
                this.dispatchInput();
            },

            //上一个视图
            _showPrevView () {
                if(this.currentViewStep === 1) {
                    return;
                }

                this.currentViewStep --;
                this.currentViewStep > 1 && this.currentValueQuene.pop();
            },
            
            headClickHandler(type) {
                // console.log('head click hanlder');
                if(type === 0) {
                    this._showPrevView();
                    return;
                }
                    
                var isPrev = type === -1;

                let index = this.currentViewStep < 2? 0 : this.currentViewStep - 2;
                let currentViewValue = this.currentValueQuene[index];
                switch(this.currentView) {
                    case 'year': 
                        isPrev? currentViewValue -= 10: currentViewValue += 10;
                        break;
                    case 'season':
                    case 'month': 
                    case 'week':
                        isPrev? currentViewValue -- : currentViewValue ++;
                        break;
                    case 'day': 
                        this._recalcMonth(isPrev? -1: 1);
                        return;
                    case 'hour':
                        this._recalcDay(isPrev);
                        return;
                    case 'minute':
                        this._recalcHour(isPrev);
                        return;
                    case 'second':
                        var current = this.currentValue;
                        var oneMinute = 60000;
                        isPrev? (current -= oneMinute) : (current += oneMinute);
                        this._setDateToQueue(current);
                        return;
                }
                this.currentValueQuene.splice(index, 1, currentViewValue);
            },

            bodyClickHandler(event) {
                // console.log('window event:', event);
                var eventTarget = event.target;

                if(eventTarget.querySelector('.fa-trash') || eventTarget.classList.contains('fa-trash')) {
                    this.currentValue = '';
                    this.dispatchInput();
                    
                    return;
                }
                if(eventTarget.nodeName !== 'TD' || eventTarget.innerText === "" 
                    || eventTarget.classList.contains('zDatepickerMin') || eventTarget.classList.contains('zDatepickerMax')) {
                    return;
                }

                var value = parseInt(eventTarget.getAttribute('data-val') || eventTarget.innerHTML);

                if(this.currentView == 'day') {
                    //上一个月的
                    if(eventTarget.classList.contains('zDatepickerOld')) {
                        this._recalcMonth(-1);
                    }
                    else if(eventTarget.classList.contains('zDatepickerNew')) {
                        this._recalcMonth(1);
                    }
                }

                this.currentViewStep === 1? this.currentValueQuene = [value] : this.currentValueQuene.push(value);
                this.currentViewStep < this._viewOriginQuene.length? this.currentViewStep ++ : this.setCurrentValue();
            },

            bodyMouseover() {
                // var eventTarget = event.target;
                // var text = eventTarget.innerText;
                // if(eventTarget.nodeName !== 'TD' || text === "") {
                //     event.stopPropagation();
                //     return;
                // }
                // var spanTips = this.body.querySelector('.zDatepickerWeekTips');
                // if(!spanTips) {
                //     event.stopPropagation();
                //     return;
                // }
                // var weekString = this._viewValueQuene[0] + this._atLeastTwoLength(text);
                // var startDate = hz.date.getStartDateByWeek(weekString);
                // spanTips.innerText = 'Start: ' + hz.date.format(startDate);
            },

            bodyMouseout() {
                // var eventTarget = event.target;
                // if(eventTarget.nodeName !== 'TD' ||  eventTarget.innerText === "") {
                //     event.stopPropagation();
                //     return;
                // }
                // var spanTips = this.body.querySelector('.zDatepickerWeekTips');
                // if(!spanTips) {
                //     event.stopPropagation();
                //     return;
                // }
                // spanTips.innerText = '';
            },
            _setDateToQueue(currentDay){

            },
            //计算得出上一个月和下一个月份
            _recalcMonth (val) {
                // console.log('_recalcMonth:', val);
                var month = parseInt(this.currentValueQuene[1]);
                var year = parseInt(this.currentValueQuene[0]);
                // console.log(year + ': ' + month + ':' + val);
                month += val;
                if(month < 0) {
                    year --;
                    month = 11;
                }
                else if(month > 11) {
                    year ++;
                    month = 0;
                }
                this.currentValueQuene.splice(0, 1, year);
                this.currentValueQuene.splice(1, 1, month);
            },
            _recalcDay (isPrev) {
                // console.log('_recalcMonth:', val);
                const currentDate = new Date();
                currentDate.setFullYear(this.currentValueQuene[0])
                currentDate.setMonth(this.currentValueQuene[1])
                currentDate.setDate(this.currentValueQuene[2])
                if(isPrev){
                    currentDate.setDate(currentDate.getDate() - 1);
                }else{
                    currentDate.setDate(currentDate.getDate() + 1);
                }

                const year = currentDate.getFullYear(),
                    month = currentDate.getMonth(),
                    day = currentDate.getDate();

                this.currentValueQuene = [year, month, day];
            },
            _recalcHour (isPrev) {
                // console.log('_recalcMonth:', val);
                const currentDate = new Date();
                currentDate.setFullYear(this.currentValueQuene[0])
                currentDate.setMonth(this.currentValueQuene[1])
                currentDate.setDate(this.currentValueQuene[2])
                currentDate.setHours(this.currentValueQuene[3])

                if(isPrev){
                    currentDate.setHours(currentDate.getHours() - 1);
                }else{
                    currentDate.setHours(currentDate.getHours() + 1);
                }

                const year = currentDate.getFullYear(),
                    month = currentDate.getMonth(),
                    day = currentDate.getDate(),
                    hour = currentDate.getHours();

                this.currentValueQuene = [year, month, day, hour];
            }
        }
    }
</script>


<style lang="stylus" scoped>
    $hover = rgba(250, 250, 250, .15)
    $hoverColor = rgba(0, 0, 0, .5)

    .hzDatepickerWrap
        position relative
        font-size 12px
        width auto
        display inline-block
        &:focus
            outline none
        input 
            position relative
            // height 100%
            width 100%
            box-shadow none
      
    .zDatepicker
        width 240px
        min-height 160px
        table
            min-width 240px
            th 
                text-align center
                background-color #fff !important
                border-bottom 0 !important
                color #0c80ba !important
    
    .zDatepicker
        font-size 13px
        display inline-block
        width auto
        outline none
        background-color #ddd
        z-index 1060
        border-width 1px
        color #555
        background #fff
        .zDatepickerHd
            white-space nowrap
            background #3993ef
            color #fff
            height 40px
            line-height 40px
            text-align center
            position relative
            padding 5px 0
            min-width 200px
            font-size 14px
            font-weight 600
            span
                display inline-block
                cursor pointer
                min-width 38px
                height 30px
                line-height 32px
                &:hover
                    background $hover
                    color $hoverColor
            .zDatepickerPrev
                float left
            .zDatepickerNext
                float right
            .zDatepickerViewSwith
                position absolute
                height 30px
                top 5px
                left 42px
                right 42px
                
        .zDatepickerBd
            position relative
            table
                width 100%
                text-align center
                border-collapse collapse
                th, td
                    width 34px 
                    height 28px
                    line-height 28px
                    padding 0
                tr 
                    height auto
                td
                    border-bottom 0
                    cursor pointer
                    &:hover
                        background #f0f0f0 
                    &.zDatepickerOld, &.zDatepickerNew
                        color #89d7ff
                    &.zDatepickerMin, &.zDatepickerMax
                        cursor no-drop
                        color #999
                        background #fafafa
                        &:hover
                            background #fafafa
                    &.zDatepickerActive
                        background #F0F0F0
                        color #0c80ba
                    &.active
                        background #3993ef
                        color #fff

            .zDatepickerViewDay thead
                color #0c80ba
                
            .zDatepickerViewSeason
                td
                    height 45px
                    width 110px
            .zDatepickerViewMonth
                td 
                    width 80px
                    height 40px
                    line-height 40px
            .zDatepickerViewHour
                margin-top 5px
            .zDatepickerViewTime td 
                width 30px 
                height 25px
                line-height 25px
                
        
        .zDatepickerWeekTips
            position absolute
            right 13px
            bottom 8px
            color #89d7ff
</style>
                    
            



// WEBPACK FOOTER //
// src/datepicker.vue